module.exports = "/assets/data/f3d74c9c07a15c8f7b8a2f4dc27f1f64-SK15.data.json";